import { FaqList } from "@/components/FaqList";
import { SitePageShell } from "@/components/SiteHeader";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "wouter";

export default function SupportPage() {
  return (
    <SitePageShell>
      <div className="container py-10 md:py-14 max-w-2xl">
        <div className="text-xs tracking-[0.3em] uppercase text-accent-foreground/80 mb-2">
          Customer Support
        </div>
        <h1 className="font-serif text-3xl text-primary mb-1">고객센터 / FAQ</h1>
        <p className="text-sm text-muted-foreground mb-6">
          자주 묻는 질문을 먼저 확인해 보세요.
        </p>

        <Card>
          <CardContent className="px-5 py-2">
            <FaqList />
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <div className="font-serif text-lg text-primary">해결되지 않았나요?</div>
          <p className="text-sm text-muted-foreground mt-1 mb-4">
            주문에 대한 문의는 마이페이지에서 주문을 선택해 남겨 주세요.
          </p>
          <Button asChild>
            <Link href="/my">1:1 문의하기</Link>
          </Button>
        </div>
      </div>
    </SitePageShell>
  );
}
